'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Avatar = _interopDefault(require('@material-ui/core/Avatar'));
var Badge = _interopDefault(require('@material-ui/core/Badge'));
var utils = require('./utils.js');
var styledComponents = require('./styled-components.js');

var CircleAvatarWithBadge = function (props) {
    var type = props.type, imgSrc = props.imgSrc, name = props.name;
    var icon = utils.getIconFrom(type);
    var src = imgSrc || '';
    var style = { border: !icon ? '1px solid white' : 'none' };
    return (React__default.createElement(Badge, { overlap: 'circle', anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, badgeContent: React__default.createElement(styledComponents.SmallAvatar, { style: style, alt: name, src: icon }) },
        React__default.createElement(Avatar, { alt: name, src: src })));
};

module.exports = CircleAvatarWithBadge;
